import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptCuentaCorriente (params) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Cuenta Corriente",
        Subject: "cuenta-corriente",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [ `${params.label}: ${params.nombreComercial}` ] ];

      data.push([ 
        `Desde: ${this.$options.filters.fecha(params.fechaDesde)}`
      ])
      data.push([ 
        `Hasta: ${this.$options.filters.fecha(params.fechaHasta)}`
      ])

      data.push([
        '',
        '',
        '',
        'Pesos',
        '',
        '',
        'Dolares',
        '',
        '',
      ]);

      data.push([
        'Fecha de Comprobante',
        'Comprobante',
        'Número',
        'Debe',
        'Haber',
        'Saldo Acumulado',
        'Debe',
        'Haber',
        'Saldo Acumulado',
      ]);

      if (params.cuentaCorriente.length != 0) {
        params.cuentaCorriente.forEach(cuentaCorriente => {
          data.push([
            // this.$options.filters.fecha(compra.fechaRegistro),
            this.$options.filters.fecha(cuentaCorriente.fechaComprobante),
            cuentaCorriente.comprobanteTipo,
            cuentaCorriente.comprobanteNumero,
            cuentaCorriente.debePesos,
            cuentaCorriente.haberPesos,
            cuentaCorriente.saldoAcumuladoPesos,
            cuentaCorriente.debeDolares,
            cuentaCorriente.haberDolares,
            cuentaCorriente.saldoAcumuladoDolares,
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "cuenta-corriente");
      XLSX.writeFile(wb, "cuenta-corriente.xlsx");

      return;
    },
  }
}
